import Siema from 'siema'

const containers = document.querySelectorAll('.js-slider')

for (let i = 0; i < containers.length; i++) {
  containers[i].classList.add('is-loading')
}

window.addEventListener('load', () => {
  for (let i = 0; i < containers.length; i++) {
    containers[i].classList.remove('is-loading')

    let list = containers[i].querySelector('.js-slider-list')
    let prev = containers[i].querySelector('.js-slider-prev')
    let next = containers[i].querySelector('.js-slider-next')

    let timer = null

    let slider = new Siema({
      selector: list,
      duration: 600,
      easing: 'ease-in-out',
      loop: true,
      onChange () {
        startAutoplay()
      }
    })

    /**
     * Start slider autoplay and clear any previous timeout
     */
    let startAutoplay = function () {
      if (timer) {
        clearTimeout(timer)
      }

      timer = setTimeout(() => {
        timer = null
        slider.next()
      }, 5000)
    }

    startAutoplay()

    prev.addEventListener('click', () => slider.prev())
    next.addEventListener('click', () => slider.next())
  }
})



// WEBPACK FOOTER //
// ./src/components/slider/scripts.js